import React from 'react';
import { NotificationManager } from 'react-notifications';
import { useHistory } from 'react-router-dom';
import Logo from '../../../system/access/images/logo.png';
import { firebase } from '../../../system/model/firebase/firebase';
import unisATSRoutes from "../../../system/router";
import { ContainerMain } from "../../../system/styles/pages/login";

const ForgotPass = () => {
  const [state, setState] = React.useState({
    email: '',
    error: null,
  });
  const history = useHistory();

  const handleInputChange = ({ target }) => {
    const { name, value } = target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const { email } = state;
    if (email) {
      firebase
        .auth()
        .sendPasswordResetEmail(email)
        .then(async () => {
          await setState((prev) => ({ ...prev, error: '' }));
          await NotificationManager.success(
            'Si hay un correo registrado se te hara llegar un correo con informacion para recuperar su cuenta',
            '',
            3000
          );
          await history.push(unisATSRoutes.MAIN);
        })
        .catch(() => {
          NotificationManager.success(
            'Si hay un correo registrado se te hara llegar un correo con informacion para recuperar su cuenta',
            '',
            3000
          );
          history.push(unisATSRoutes.MAIN);
        });
    } else {
      setState((prev) => ({ ...prev, error: 'El email esta vacío' }));
    }
  };
  return (
    <ContainerMain>
      <div className="login">
        <aside
          className="login-left"
          style={{
            backgroundImage: `url(https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/recursos%20ats%2Flogin%2Flogin.jpg?alt=media&token=0a9db26d-1fd5-4b57-a9a9-a04e51cf20cc)`,
          }}
        />
        <div className="login-right">
          <img src={Logo} alt="" />
          <p className="text-center">Coloque su correo electrónico:</p>
          <form>
            {state?.error ? <p>{state?.error}</p> : ''}
            <div className="form-group">
              <input
                type="email"
                placeholder="ejemplo@ejemplo.com"
                name="email"
                value={state?.email}
                onChange={handleInputChange}
              />
            </div>

            <button type="button" onClick={handleSubmit}>
              Recuperar
            </button>
          </form>
        </div>
      </div>
    </ContainerMain>
  );
};

export default ForgotPass;
